import DetailCard from 'v2/components/DetailCard';
import useAccountDetails from 'v2/layouts/AccountWorkspaceLayout/components/AccountDetailsSection/hooks/useAccountDetails';
import useTranslation from 'v2/layouts/AccountWorkspaceLayout/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const AccountDetailsSection: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => {
    const { handleEditMyInformation, myInformationFields, rolesFields } = useAccountDetails();

    const { EDIT, MY_INFORMATION, ROLES } = useTranslation();

    return (
        <div className={`${className} ${styles.accountDetailsSection}`} data-testid={testId}>
            <DetailCard
                editText={EDIT}
                fields={myInformationFields}
                onEdit={handleEditMyInformation}
                title={MY_INFORMATION}
            />

            <DetailCard editText={EDIT} fields={rolesFields} title={ROLES} />
        </div>
    );
};

export default AccountDetailsSection;
